(function(){
  var root=document.querySelector('[data-tugc]'); if(!root) return;
  var cards=[].slice.call(root.querySelectorAll('[data-tugc-card]'));
  var lb=root.querySelector('[data-tugc-lb]'), stage=root.querySelector('[data-tugc-stage]'), lbProd=root.querySelector('[data-tugc-lbprod]');
  // The section sits inside a theme wrapper that forms its own stacking context, so a fixed overlay
  // inside it lost to the z:900 edge tab. Hoist the lightbox to <body>; its CSS is .tugc-lb-*, not descendant-scoped.
  document.body.appendChild(lb);
  var canHover=window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var current=-1, homeCard=null;

  // Sources sit in data-src so nothing downloads until hovered/clicked (720x1280 files, several MB each).
  function load(v){
    if(v.dataset.loaded) return;
    v.querySelectorAll('source').forEach(function(s){ s.src=s.dataset.src; });
    v.load(); v.dataset.loaded='1';
  }
  function vidOf(card){ return card.querySelector('.tugc-vid'); }

  // Hover = muted preview (desktop only). Leave = pause + rewind so the poster frame returns.
  if(canHover){
    cards.forEach(function(card){
      var v=vidOf(card);
      card.addEventListener('mouseenter',function(){
        if(!lb.hidden) return;
        load(v); v.muted=true;
        var p=v.play(); if(p&&p.catch) p.catch(function(){});
        card.classList.add('is-previewing');
      });
      card.addEventListener('mouseleave',function(){
        if(v.parentNode!==card.querySelector('.tugc-open')) return;
        v.pause(); try{ v.currentTime=0; }catch(e){}
        card.classList.remove('is-previewing');
      });
    });
  }

  // Click = lightbox with sound. The tile's own <video> is moved into the modal so buffered data is reused.
  function open(i){
    if(i<0||i>=cards.length) return;
    if(current>-1) putBack();
    var card=cards[i], v=vidOf(card);
    homeCard=card; current=i;
    load(v);
    stage.appendChild(v);
    lbProd.innerHTML=card.querySelector('.tugc-prod').innerHTML;
    v.muted=false; v.loop=true; v.controls=true;
    try{ v.currentTime=0; }catch(e){}
    lb.hidden=false; document.body.classList.add('tugc-lock');
    var p=v.play();
    if(p&&p.catch) p.catch(function(){ v.muted=true; v.play().catch(function(){}); });
    lb.querySelector('.tugc-lb-prev').style.visibility = i>0 ? 'visible' : 'hidden';
    lb.querySelector('.tugc-lb-next').style.visibility = i<cards.length-1 ? 'visible' : 'hidden';
    lb.querySelector('.tugc-lb-x').focus();
  }
  function putBack(){
    if(!homeCard) return;
    var v=stage.querySelector('.tugc-vid');
    if(v){ v.pause(); v.muted=true; v.controls=false; try{ v.currentTime=0; }catch(e){}
      homeCard.querySelector('.tugc-open').insertBefore(v, homeCard.querySelector('.tugc-chip')); }
    homeCard.classList.remove('is-previewing');
    homeCard=null; current=-1;
  }
  function close(){
    putBack();
    lb.hidden=true; document.body.classList.remove('tugc-lock');
  }

  cards.forEach(function(card,i){
    card.querySelector('[data-tugc-open]').addEventListener('click',function(){ open(i); });
  });
  lb.querySelectorAll('[data-tugc-close]').forEach(function(b){ b.addEventListener('click',close); });
  lb.querySelectorAll('[data-tugc-step]').forEach(function(b){
    b.addEventListener('click',function(){ open(current+parseInt(b.getAttribute('data-tugc-step'),10)); });
  });
  document.addEventListener('keydown',function(ev){
    if(lb.hidden) return;
    if(ev.key==='Escape') close();
    else if(ev.key==='ArrowRight') open(current+1);
    else if(ev.key==='ArrowLeft') open(current-1);
  });
})();
